import { Logo } from './Logo'
import { ComplianceBadges } from './ComplianceBadges'
import { footerColumns, legalLinks, type NavLink } from '../lib/site-nav'

const extra = (l: NavLink) =>
  l.external ? { target: '_blank' as const, rel: 'noreferrer' as const } : {}

export function Footer() {
  return (
    <footer className="border-t border-ink-100 bg-paper-soft/40">
      <div className="container-wide grid grid-cols-2 gap-10 py-16 md:grid-cols-6">
        <div className="col-span-2">
          <Logo />
          <p className="mt-4 max-w-xs text-[14px] leading-relaxed text-ink-500">
            The LLM engineering platform for teams that ship AI to production.
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-2">
            {['EU · US · UK · APAC', 'Open Source · Apache2'].map((tag) => (
              <span
                key={tag}
                className="rounded-full border border-ink-100 px-3 py-1 text-[11px] font-medium text-ink-500"
              >
                {tag}
              </span>
            ))}
          </div>
          <ComplianceBadges />
        </div>
        {footerColumns.map((c) => (
          <div key={c.title} className="text-[13.5px]">
            <h4 className="font-mono text-[10px] uppercase tracking-[0.18em] text-ink-400">
              {c.title}
            </h4>
            <ul className="mt-4 space-y-2.5">
              {c.links.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    {...extra(l)}
                    className="text-ink-700 transition hover:text-ink-900"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-ink-100">
        <div className="container-wide flex flex-col items-center justify-between gap-3 py-6 text-[11.5px] text-ink-400 md:flex-row">
          <span>© 2026 Reasoning Engine B.V. · Built in Amsterdam.</span>
          <div className="flex items-center gap-5">
            {legalLinks.map((l) => (
              <a key={l.label} href={l.href} {...extra(l)} className="hover:text-ink-700">
                {l.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}
